import { LAYOUT_CONSTANTS } from "@src/constants";
import { useApplicationContext } from "@src/context";
import { useTimerContext } from "@src/context/TimerContext";
import { useNavigateWithUTM } from "@src/hooks/useNavigateWithUTM";
import ClientLogsService from "@src/services/client-logs.service";
import { resolveProviderSelectionPath } from "@src/utils/provider-back-path";
import { styled } from "@uhg-abyss/web/tools/styled";
import { Button } from "@uhg-abyss/web/ui/Button";
import { ModalDialog } from "@uhg-abyss/web/ui/ModalDialog";
import { Text } from "@uhg-abyss/web/ui/Text";
import { useState } from "react";

const StyledModalDialog = styled(ModalDialog, {
  "abyss-modal-base-header-container": {
    padding: "16px",
  },
  "abyss-modal-base-body": {
    padding: "16px",
  },
});

export const ScheduleTimeOutModal = () => {
  const { showTimeoutModal, setShowTimeoutModal, handleSessionTimeout } = useTimerContext();
  const { data } = useApplicationContext();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigateWithUTM();

  const handleClose = async () => {
    if (isLoading) return;
    setIsLoading(true);
    await handleSessionTimeout();
    setIsLoading(false);
    setShowTimeoutModal(false);
    navigate(resolveProviderSelectionPath(data.providerBackPath));
  };

  const modalFooter = (
    <div
      style={{
        display: "flex",
        justifyContent: "flex-start",
        width: "100%",
        paddingTop: "16px",
      }}
    >
      <Button
        data-testid="test-id-schedule-timeout-understand-button"
        id="obc-schedule-timeout-modal-back-provider-profile-btn"
        data-obc-label="Schedule Timeout Modal Book again Button"
        onClick={handleClose}
        isLoading={isLoading}
        ariaLoadingLabel="Navigating back to provider profile to book slot again"
      >
        Book again
      </Button>
    </div>
  );

  return (
    <StyledModalDialog
      data-testid="test-id-schedule-timeout-modal"
      data-id="obc-schedule-timeout-modal"
      data-obc-label="Schedule Timeout Modal"
      header="Your scheduling time ran out"
      isOpen={showTimeoutModal}
      footer={modalFooter}
      onClose={() => {
        ClientLogsService.logClick(
          data.userUuid || "unknown",
          "ScheduleTimeOutModal",
          "obc-schedule-timeout-modal-close-btn",
          "Schedule Timeout Modal Close Button",
        );
        handleClose();
      }}
      closeOnClickOutside={false}
      size={LAYOUT_CONSTANTS.modalDialogWidth}
    >
      <Text>
        Your appointment hold has expired. Please select a time slot to book your appointment again.
      </Text>
    </StyledModalDialog>
  );
};
